const headerStyle = { style: "padding: 0.5rem 1rem" }
const footerStyle = { style: "padding: 0.5rem 1rem" }

export const dialogContentPt = {
  header: headerStyle,
  footer: footerStyle,
  content: { style: "padding: 0.25rem 1rem" }
}

export const dialogContentPtLoose = {
  header: headerStyle,
  footer: footerStyle,
  content: { style: "padding: 0.5rem 1rem" }
}

export const dialogHeaderFooterPt = {
  header: headerStyle,
  footer: footerStyle
}

export const dialogHeaderPt = {
  header: headerStyle
}
